export default [
    {
        "id": "ad25431f-9038-4160-b914-1f0cb7f24a0e",
        "state_name": "Acre",
        "uf_code": "12",
        "uf": "AC"
    },
    {
        "id": "e410ce85-05d7-494e-8e4e-29f22feeb729",
        "state_name": "Alagoas",
        "uf_code": "27",
        "uf": "AL"
    },
    {
        "id": "561d181e-a45d-421a-b4d7-d636b8db4158",
        "state_name": "Amazonas",
        "uf_code": "13",
        "uf": "AM"
    },
    {
        "id": "f9942929-8618-469e-8236-c7ce2e200889",
        "state_name": "Amapá",
        "uf_code": "16",
        "uf": "AP"
    },
    {
        "id": "64d2c19b-7ca5-42b4-b324-7237f321c60b",
        "state_name": "Bahia",
        "uf_code": "29",
        "uf": "BA"
    },
    {
        "id": "96d95363-7627-497a-a5a5-70967e8a71ed",
        "state_name": "Ceará",
        "uf_code": "23",
        "uf": "CE"
    },
    {
        "id": "1c53bb46-a5fe-467f-bfd7-0bd42c30c6f7",
        "state_name": "Distrito Federal",
        "uf_code": "53",
        "uf": "DF"
    },
    {
        "id": "e931ad53-a7ed-404a-a5a0-cce073bffc70",
        "state_name": "Espírito Santo",
        "uf_code": "32",
        "uf": "ES"
    },
    {
        "id": "dfefaa8b-eb70-4e44-a43b-776397c41783",
        "state_name": "Goiás",
        "uf_code": "52",
        "uf": "GO"
    },
    {
        "id": "f7c428c0-c75d-420e-b76e-a821b18a7afb",
        "state_name": "Maranhão",
        "uf_code": "21",
        "uf": "MA"
    },
    {
        "id": "cd730ecc-8fb1-4897-8dd6-a0f84e8f33f4",
        "state_name": "Minas Gerais",
        "uf_code": "31",
        "uf": "MG"
    },
    {
        "id": "8d486228-fcf4-465d-8fd9-ed10acf8cb4c",
        "state_name": "Mato Grosso do Sul",
        "uf_code": "50",
        "uf": "MS"
    },
    {
        "id": "017caff6-54e5-46c6-9311-f8341157b1ac",
        "state_name": "Mato Grosso",
        "uf_code": "51",
        "uf": "MT"
    },
    {
        "id": "f0ad2a7a-de43-43f6-8872-627d1d6e0837",
        "state_name": "Pará",
        "uf_code": "15",
        "uf": "PA"
    },
    {
        "id": "02424fb9-3518-4ab7-9a36-1fd2b44d84c0",
        "state_name": "Paraíba",
        "uf_code": "25",
        "uf": "PB"
    },
    {
        "id": "75abc23a-36cb-447a-8bf9-453389a1323a",
        "state_name": "Pernambuco",
        "uf_code": "26",
        "uf": "PE"
    },
    {
        "id": "65bba539-9674-4188-94ef-47e393991850",
        "state_name": "Piauí",
        "uf_code": "22",
        "uf": "PI"
    },
    {
        "id": "dd725166-2d89-4c14-82c8-fbb47cf47d0e",
        "state_name": "Paraná",
        "uf_code": "41",
        "uf": "PR"
    },
    {
        "id": "6e6c31b7-4592-49db-a723-1a3ad350c89b",
        "state_name": "Rio de Janeiro",
        "uf_code": "33",
        "uf": "RJ"
    },
    {
        "id": "9d120d49-9495-4d43-b000-2fc10618ecea",
        "state_name": "Rio Grande do Norte",
        "uf_code": "24",
        "uf": "RN"
    },
    {
        "id": "867857f7-46d7-4ae2-88b4-2e09ec70cfaa",
        "state_name": "Rondônia",
        "uf_code": "11",
        "uf": "RO"
    },
    {
        "id": "201dbb64-68f9-4147-ac75-39fa96d9628c",
        "state_name": "Roraima",
        "uf_code": "14",
        "uf": "RR"
    },
    {
        "id": "afecf8e8-393d-453a-9039-dbc571512ecd",
        "state_name": "Rio Grande do Sul",
        "uf_code": "43",
        "uf": "RS"
    },
    {
        "id": "60a54726-cd28-4826-9272-add2a823a8cc",
        "state_name": "Santa Catarina",
        "uf_code": "42",
        "uf": "SC"
    },
    {
        "id": "cce93573-2c77-41f3-9fd5-66e04a7cf4b8",
        "state_name": "Sergipe",
        "uf_code": "28",
        "uf": "SE"
    },
    {
        "id": "170a2f51-6a7e-4fbb-9d89-5c29d42921ae",
        "state_name": "Sao Paulo",
        "uf_code": "35",
        "uf": "SP"
    },
    {
        "id": "282c76a9-4413-48c2-a0cc-938253c28477",
        "state_name": "Tocantins",
        "uf_code": "17",
        "uf": "TO"
    }
]


// WEBPACK FOOTER //
// ./src/_components/Address/StateLocation/data.js